import axios from 'axios'
import qs from 'qs'
import util from '../scripts/common/util'
// axios 配置
//let hostUrl = 'http://192.168.123.113:8568/';//薛嘉淇
//let hostUrl = 'http://192.168.123.93:8568/';//宋居光
//let hostUrl = 'http://192.168.123.96:8568/';//汪志
//let hostUrl = 'http://192.168.123.101:8568/';//孙强
//let hostUrl = 'http://192.168.123.101:8568/';//丁涛
//let hostUrl = 'http://15w07q0502.51mypc.cn:37796/';//孙强
//let hostUrl = 'http://192.168.123.106:8568/';//朱亚军
//let hostUrl = 'http://47.98.174.100:8999/';// https开发
//let hostUrl = 'http://116.62.62.201:8568/';//临时
//let hostUrl = 'https://test04.sso.jia-r.com/';//开发新
// let hostUrl = 'https://test03.sso.yun-r.com/';//https测试测试新
// let hostUrl = 'https://develop.sso.yun-r.com';//临时环境
// let hostUrl = 'https://test01.sso.yun-r.com';//临时环境
let hostUrl = 'https://test02.sso.yun-r.com';//临时环境
// let hostUrl = 'https://cluster.sso.yun-r.com';//临时环境
// let hostUrl = 'https://sso.yun-r.com';//正式新
//timeout: 60000;
//headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
//headers:{'content-type': 'application/json;charset=UTF-8'}
let instance = axios.create({
    baseURL:hostUrl
});
export function fetch(url, param, formData=false, timeout = 10000) {
    return new Promise((resolve, reject) => {
        let userParam = {
            myUserName: window.sessionStorage.getItem('myUserName'),
            token: window.sessionStorage.getItem('token'),
        };
    let params;
    let contentType = "application/x-www-form-urlencoded;charset=UTF-8";
    if (formData) {
        //如果有文件流需要formData格式，分开传参json格式的param和文件格式的formData，其他接口默认formData为false
        //form表单所需contentType
        contentType = 'multipart/form-data';
    }
    //验签value加密处理
    let valueStr = util.jsonSort(Object.assign(userParam, param));
    let createTime=util.formatDate.format(new Date(), 'yyyyMMddhhmmss');
    let key="ITL87v5ik7*=()55ilpp751O";
    let sign=util.getmd5(valueStr+createTime+key);
    // console.log(sign)
    //AES加密
    let pubkey="5278MMN5412365UH"
    let data=Object.assign(userParam, param,{"createTime":createTime,"sign":sign});
    console.log(data)
    let ciphertext = util.encryptByAES(JSON.stringify(data), pubkey);
    if (formData) {
      formData.append("encryptScript", ciphertext);
      params=formData;
    }else {
      params=qs.stringify(Object.assign({encryptScript:ciphertext}))
    }
    let config = {
      headers: {'Content-Type': contentType},
      timeout: timeout,
    };
    instance.post(url, params, config)
      .then(response => {
        let encryptScript=util.decryptByAES(response.data.encryptScript,pubkey);
        if(JSON.parse(encryptScript).allData){
            console.log(url)
        console.log(JSON.parse(JSON.parse(encryptScript).allData))
          let resSign=util.getmd5(JSON.parse(encryptScript).allData+JSON.parse(encryptScript).createTime+key)
          if(resSign == JSON.parse(encryptScript).sign) {//验签
            resolve(JSON.parse(JSON.parse(encryptScript).allData));
          }else{
            resolve(JSON.parse('{"msgCode":"SmsgCode","msg":"验签失败"}'));
          }
        }else{
          resolve(JSON.parse(encryptScript));
        }
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
    })
}
export default {
    /**
     * 用户登录
     */
    login(params) {
        return fetch('sso/login', params)
    },
    /**
     * 判断是否需要登录
     */
    checkLogin(params) {
        return fetch('sso/checkLogin', params)
    },
    /**
     * 获取请求地址
     */
    getHost() {
        return hostUrl
    },
    
}



// WEBPACK FOOTER //
// ./src/fetch/api.js